import { RSet } from "../../collections";
import { makeImmutable, Tristate } from "../../core";
/*
 * `Always available` availabity calcualtaion strategy
 */
export class Available {
    constructor() {
        makeImmutable(this);
    }
    get isAvailable() {
        return Tristate.True;
    }
    get unavailabilityReasons() {
        return RSet.empty();
    }
    accept(availabilityVisitor) {
        availabilityVisitor.visitAvailable(this);
    }
}
